import { Button } from "./ui/button";
import { useLanguage } from "../contexts/LanguageContext";

const CircularFlag = ({ code, isActive = false }: { code: string; isActive?: boolean }) => {
  const flagUrl = code === "pt" ? "https://flagcdn.com/w80/pt.png" : "https://flagcdn.com/w80/gb.png";

  return (
    <div
      className={`
        relative w-6 h-6 rounded-full
        transition-all duration-200 ease-in-out
        ${isActive ? "bg-teal-500" : ""}
      `}
    >
      <div className="absolute inset-0.5 rounded-full overflow-hidden">
        <img
          src={flagUrl}
          alt={`${code.toUpperCase()} flag`}
          className={`w-full h-full object-cover transition-opacity duration-200
            ${isActive ? "opacity-100" : "opacity-40 hover:opacity-70"}`}
        />
      </div>
    </div>
  );
};

export const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "pt" ? "en" : "pt");
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-1 bg-black/5 p-1 rounded-full hover:bg-black/10"
    >
      <CircularFlag code="pt" isActive={language === "pt"} />
      <CircularFlag code="gb" isActive={language === "en"} />
    </Button>
  );
};
